module.exports = __webpack_public_path__ + "static/fencing-flashing-357e5522b5f236a1394487f3d43ce090.jpg";